import { render, staticRenderFns } from "./RingChart.vue?vue&type=template&id=4036bf8f&scoped=true&"
import script from "./RingChart.vue?vue&type=script&lang=js&"
export * from "./RingChart.vue?vue&type=script&lang=js&"
import style0 from "./RingChart.vue?vue&type=style&index=0&id=4036bf8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4036bf8f",
  null
  
)

export default component.exports